// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Products_GetResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response for GET /so/products/get/{id} — returns a single product plus
 * its gallery images.
 *
 * Wire shape (Option A — typed envelope):
 *   dados: { product: { ... }, images: Products_ListImageRow[] }
 *
 * The product itself remains shape-erased (dynamic DB row from
 * `so_products_model`); the gallery is typed via `Products_ListImageRow`
 * so the frontend reads ids, urls, sort_order and is_primary off a
 * concrete TS interface.
 */
import type { Products_ListImageRow } from './Products_ListImageRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Products_GetResponseDados {
product: Record<string, number | string | boolean | null>
images: Products_ListImageRow[]
}

export type Products_GetResponse = ApiResponse<Products_GetResponseDados>;

registerResponseContract('Products_GetResponse', {
  product: { type: 'object',  required: true },
  images: {
    type: 'array',
    required: true,
    items: {
      so_product_image_id:            { type: 'number',  required: true },
      so_product_id:                  { type: 'number',  required: true },
      so_product_image_filename:      { type: 'string',  required: true },
      so_product_image_url:           { type: 'string',  required: true },
      so_product_image_thumbnail_url: { type: 'string',  required: true },
      so_product_image_alt_text:      { type: 'string',  required: false },
      so_product_image_sort_order:    { type: 'number',  required: true },
      so_product_image_is_primary:    { type: 'boolean', required: true },
    },
  },
})
